import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

export const firebaseConfig = {
  projectId: "bingo-app---dev",
  appId: "1:1086057772449:web:e35150fca5fd350e99c7e0",
  storageBucket: "bingo-app---dev.appspot.com",
  locationId: "us-central",
  apiKey: "AIzaSyCPd_Z6cCNsSouBawCaXG3k0TUpoGioVS8",
  authDomain: "bingo-app---dev.firebaseapp.com",
  messagingSenderId: "1086057772449",
  measurementId: "G-DG597N25CD",
};
